import { render, staticRenderFns } from "./login-footer.vue?vue&type=template&id=9f1476c0&"
import script from "./login-footer.vue?vue&type=script&lang=js&"
export * from "./login-footer.vue?vue&type=script&lang=js&"
import style0 from "./login-footer.vue?vue&type=style&index=0&id=9f1476c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports